import React from 'react';

import {useTooltip} from '../../../hooks/useTooltip';

export default function Title({ header, tooltip, }) {
  const tooltipRef = useTooltip();

  return (
    <div className="card-title custom-card">
      <div className="view-title">
        <i
          className="left material-icons estimate-header-popover"
          data-position="right"
          data-delay="50" 
          data-tooltip={tooltip}
          ref={tooltipRef}
        >
          info
        </i>
        <span className="title left">
          {header}
        </span>
      </div>
    </div>
  );
}
